import React, { useEffect, useState } from "react";
import { Angle } from "../../../assets/ThemeIcon";
import Shape from "./shapes/Shape";
import ShapMobile1 from "./shapes/ShapMobile1";
import ShapMobile2 from "./shapes/ShapMobile2";

import Button from "../../../components/Button";
import BannerPlayer from "./BannerPlayer";
// import banner from "./img/banner-image.png";
// import banner_mobile from "./img/banner-mobile-image.png";
import ShapeMobile3 from "./shapes/ShapeMobile3";

const Banner = () => {
	const [mobileScreen, setMobileScreen] = useState(true);

	const handleMobile = () => {
		const width = window.innerWidth;
		if (width < 991) {
			setMobileScreen(true);
		} else {
			setMobileScreen(false);
		}
	};

	useEffect(() => {
		handleMobile();
		window.addEventListener("resize", handleMobile);
	}, []);

	return (
		<section className="banner-section">
			<div className="shape-1">
				{!mobileScreen ? <Shape /> : <ShapMobile1 />}
			</div>
			<div className="shape-2">{mobileScreen && <ShapMobile2 />}</div>
			<div className="shape-3">{mobileScreen && <ShapeMobile3 />}</div>
			<div className="container">
				<div className="banner-wrapper">
					<div className="anime-thumb">
						{/* <img
							src={mobileScreen ? banner_mobile : banner}
							alt=""
							className="banner-img"
						/> */}
						<div className="center-align-video">
							<BannerPlayer />
						</div>
					</div>
					<div className="banner-content">
						<h1 className="title">
							Algorand’s Premium Launchpad Protocol
						</h1>
						<p className="text">
							Get early access to upcoming Algorand projects through
							yLaunch - Offering tomorrows great projects, today!
						</p>
						<ul>
							<li>
								<Angle />
								Decentralised
							</li>
							<li>
								<Angle />
								Transparent
							</li>
							<li>
								<Angle />
								Use YLDY to participate
							</li>
						</ul>
						<div className="btn-grp">
							<Button text="Project Application" link="/" />
							<Button
								text="Preparing to Launch"
								link="/"
								className="btn-outline"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Banner;
